var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.70857L10.7914 0.5L6 5.29143L1.20857 0.5L0 1.70857L4.79143 6.5L0 11.2914L1.20857 12.5L6 7.70857L10.7914 12.5L12 11.2914L7.20857 6.5L12 1.70857Z",
    fill: "#F15130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCloseIcon);
export default __webpack_public_path__ + "static/media/plan_Close_icon.b90658d45fef83e7a4b839bc49428ead.svg";
export { ForwardRef as ReactComponent };